<template>
	<ui-slideover v-on:close="$emit('close')" title="Filter by">
		<slot>
			<div class="flex flex-col h-full divide-y divide-gray-200 border-t">
				<ui-filter-renderer
					:filter="filter"
					:filter-options="filterOptions"
					v-on:select-my-products="selectMyProducts()"
					v-on:filter-clear="clearFilters()"
					v-on:filter-close="$emit('close')"
				/>
			</div>
		</slot>
	</ui-slideover>
</template>

<script>
export default {
	props: {
		filterOptions: {
			type: Object,
			required: true,
		},
		value: {
			type: Object,
		},
	},
	data() {
		let productGrade = this.filterOptions.productGrades,
			allGradesIds = [];
		Object.keys(productGrade).forEach(function (option) {
			allGradesIds.push(productGrade[option].id);
		});

		let userFavoriteProductGrades = allGradesIds.filter((g) =>
			this.checkFavouriteProductInFilter(g)
		);
		return {
			emptyFilter: {
				locationHubs: [],
				productGrades: [],
				productYears: [],
				mine: 0,
				dateType: [],
				monthType: {
					month_from: null,
					month_to: null,
				},
			},
			filter: Object.assign({}, this.value),
			userFavoriteProductGrades: userFavoriteProductGrades,
		};
	},
	watch: {
		filter: {
			deep: true,
			handler: function (val) {
				console.log("THERE");
				this.filterOptions.mine = this.filter.mine;
				this.filterOptions.monthType.month_from =
					this.filter.monthType.month_from;
				this.filterOptions.monthType.month_to = this.filter.monthType.month_to;
				this.$emit("input", val);
				console.log("EMIT", val);
			},
		},
	},
	methods: {
		clearFilters() {
			this.filter = JSON.parse(JSON.stringify(this.emptyFilter));
			let filterOptions = this.filterOptions;
			Object.keys(filterOptions).forEach(function (field) {
				if (field != "monthType") {
					Object.keys(filterOptions[field]).forEach(function (option) {
						filterOptions[field][option].checked = false;
					});
				}
				filterOptions.mine = 0;
			});
		},
		selectMyProducts() {
			this.filter.productGrades = this.userFavoriteProductGrades;
		},
		checkFavouriteProductInFilter(type) {
			let favouriteTypes = this.$inertia.page.props.user.favorite_product_types,
				flag = false;
			Object.keys(favouriteTypes).forEach(function (option) {
				if (type.includes(favouriteTypes[option])) {
					flag = true;
				}
			});
			return flag;
		},
		callToApplyFilter() {
			this.spinner = true;
			this.$emit("apply");
		},
	},
};
</script>
